import { render, staticRenderFns } from "./PreviewWork.vue?vue&type=template&id=a1c015f0&scoped=true"
import script from "./PreviewWork.vue?vue&type=script&lang=js"
export * from "./PreviewWork.vue?vue&type=script&lang=js"
import style0 from "./PreviewWork.vue?vue&type=style&index=0&id=a1c015f0&prod&lang=scss"
import style1 from "./PreviewWork.vue?vue&type=style&index=1&id=a1c015f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c015f0",
  null
  
)

export default component.exports